// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-disabled[data-v-52f2d8b1]  .el-upload{cursor:not-allowed}.is-disabled[data-v-52f2d8b1]  .el-upload .btn{color:#999!important}", ""]);
// Exports
module.exports = exports;
